var _defs, _g, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSweater(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.965,
    height: 56.966,
    viewBox: "0 0 57.965 56.966",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.a{stroke:#4c4c4e;stroke-linecap:round;stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.365 4.41)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.7,47.026H7.683a1.929,1.929,0,0,1-1.858-1.905V15.756a10.476,10.476,0,0,1,6.463-9.633l7.108-3H32.967l7.109,3a10.476,10.476,0,0,1,6.462,9.632V45.121a1.929,1.929,0,0,1-1.858,1.905H42.661",
    transform: "translate(-5.825 -3.125)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M34,34.231v3.731H30.125",
    transform: "translate(4.772 9.67)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.175,34.231v3.731h3.877",
    transform: "translate(-5.236 9.67)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M38.945,11.394V39.735a1.889,1.889,0,0,1-.581,1.36,1.957,1.957,0,0,1-1.394.545H11.839A1.922,1.922,0,0,1,9.9,39.735V11.394",
    transform: "translate(-4.048 0.276)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.25,32.825V34.73a1.922,1.922,0,0,0,1.939,1.905h21.29a1.921,1.921,0,0,0,1.9-1.905V32.825",
    transform: "translate(-3.459 9.091)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.275,3.125c.646,6.907,6.786,12.349,6.786,12.349S28.2,10,28.846,3.125",
    transform: "translate(-1.704 -3.125)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.5,4.325c3.016,11.723,10.771,15.454,10.771,15.454s7.755-3.731,10.771-15.454",
    transform: "translate(-2.914 -2.631)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 57.965,
    height: 56.966
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSweater);
export default __webpack_public_path__ + "static/media/Sweater.52ec79d44331c180f2cc164eea86bdaf.svg";
export { ForwardRef as ReactComponent };